import { JsonSchemaUtils, Objects } from "../../util";
import { OpenAPIV3 } from "../../@types";
import { InputEnumOption } from "../../ui/InputEnumOption";

/** Defines either source or target in DataMapper */
export class DataMapperMember<T> {

  /** Name of the member, typically the typeName in schema. */
  public name: string;

  /** Schema for the member IF explicitly set. */
  public schema: OpenAPIV3.NonArraySchemaObject;

  /** The value of the member. */
  public value: T[];

  /** If true, the member is two dimensional table, not a hierarchical object. */
  public isTable: boolean;

  /**
   * Gets the schema either based on the defined schema or based on set data value if explicit schema is defined.
   * @param typeResolve If "guess" will attempt to guess the data type/format based on the value.
   * Otherwise, uses string type for all items.
   */
  public getSchema(typeResolve: "string" | "guess" = "guess"): OpenAPIV3.NonArraySchemaObject | undefined {
    if (this.schema) {
      return this.schema;
    }
    if (this.value?.length) {
      return JsonSchemaUtils.guessSchema(this.value[0]!, typeResolve);
    }
    return undefined;
  }

  /**
   * Gets the keys of first-level items in the data based on getSchema (cached).
   */
  public get keys(): string[] {
    this.assureKeys();
    return this.$cache.keys;
  }

  /**
   * Gets all the properties (the entire tree) from the schema.
   * Values are InputEnumOptions (typically used in UI) where value and text are
   * the property path, e.g. "owner.avatar.sortableName" and title shows the title or description from the schema.
   */
  public get allKeys(): InputEnumOption {
    this.assureKeys();
    return this.$cache.allKeys;
  }

  private assureKeys() {
    if (!Objects.equal(this.schema || this.value?.[0] , this.$cache.schema)) {
      const schema = this.getSchema();
      if (!schema?.properties) {
        this.$cache.keys = [];
        this.$cache.allKeys = [];
      } else {
        this.$cache.keys = Object.keys(schema.properties);
        this.$cache.allKeys = JsonSchemaUtils.getAllProperties(schema);
      }
      this.$cache.schema = this.schema || this.value?.[0];
    }
  }

  private $cache: any = {};

}